import store from '../../../index-store';
import { logoutSuccessful } from '../../../pages/shared/loginuser/actions';
import { unsetUserInfo } from '../user/userActions';

export const optionHandle = (option, isTimeOut) => {
	switch (option) {
		case 'Log Out': {
			console.debug("LOCAL STORAGE CLEARED");
			sessionStorage.clear();
			localStorage.clear();
			store.dispatch(unsetUserInfo());

			// Dispatch logout to clear Redux state and destroy backend session
			store.dispatch(logoutSuccessful(isTimeOut));
			sessionStorage.clear();
			localStorage.clear();
			break;
		}
		default:
			break;
	}
};
